import { render, staticRenderFns } from "./SummaryCharges.vue?vue&type=template&id=d60bf7e0&"
import script from "./SummaryCharges.vue?vue&type=script&lang=js&"
export * from "./SummaryCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VCheckbox,
  VDataTable,
  VTooltip,
})
